import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "playlistId", "showNotification", "onClick", "use", "onSuccess", "textAlign"];
import Raven from 'raven-js';
import UsageTracker from '../../../utils/UsageTracker';
import { usePlaylistSaveStatus } from '../myPlaylistsHooks';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { View } from 'foundations-components/components/View';
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import { SavePlaylistNotification, UnsavePlaylistNotification } from './PlaylistNotifications';
import { jsx as _jsx } from "react/jsx-runtime";
export const SavePlaylistsToggleIconMessage = ({
  isSaved
}) => isSaved ? /*#__PURE__*/_jsx(FormattedMessage, {
  message: "learningCenter.savedItems.tooltips.savedHover"
}) : /*#__PURE__*/_jsx(FormattedMessage, {
  message: "learningCenter.savedItems.tooltips.unsavedHover"
});
export const SavePlaylistButton = _ref => {
  let {
      children,
      playlistId,
      showNotification = true,
      onClick,
      use = 'unstyled',
      onSuccess,
      textAlign = 'start'
    } = _ref,
    buttonProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    isSaved,
    isLoading,
    togglePlaylistSaveStatus
  } = usePlaylistSaveStatus(playlistId);
  const handleOnClick = e => {
    if (isLoading) return;
    if (onClick) onClick(e);
    const trackingAction = isSaved ? 'remove-playlist' : 'save-playlist';
    UsageTracker.track('playlistInteraction', {
      action: trackingAction,
      playlistId
    });
    togglePlaylistSaveStatus().then(() => {
      if (showNotification) {
        if (isSaved) {
          FloatingAlertStore.addAlert({
            message: /*#__PURE__*/_jsx(UnsavePlaylistNotification, {
              playlistId: playlistId
            }),
            type: 'success'
          });
        } else {
          FloatingAlertStore.addAlert({
            message: /*#__PURE__*/_jsx(SavePlaylistNotification, {
              playlistId: playlistId
            }),
            type: 'success'
          });
        }
      }
      onSuccess === null || onSuccess === void 0 || onSuccess();
    }).catch(() => {
      Raven.captureMessage(`Achievements: error saving playlist`, {
        extra: {
          playlistId,
          isSaved
        }
      });
    });
  };
  return /*#__PURE__*/_jsx(Button, Object.assign({}, buttonProps, {
    disabled: isLoading,
    onClick: handleOnClick,
    use: use,
    children: /*#__PURE__*/_jsx(View, {
      inlineSize: "100%",
      textAlign: textAlign,
      children: children || /*#__PURE__*/_jsx(SavePlaylistsToggleIconMessage, {
        isSaved: isSaved || null
      })
    })
  }));
};
export default SavePlaylistButton;